import DesktopMenu from './components/DesktopMenu/DesktopMenu';
import MobileMenu from './components/MobileMenu/MobileMenu'
import styled from './Menu.module.scss'


const Menu = () => {

  return (

    <div className={styled.wrapper}>
      <DesktopMenu/>
      <MobileMenu/>
    </div>
  )
}

export default Menu